import RoleRoute from "../components/RoleRoute";

export default function ProtectedRoleElement({ allowedRoles, children }) {
  return <RoleRoute allowedRoles={allowedRoles}>{children}</RoleRoute>;
}
